(function () {
    'use strict';

    function formatMoney(cents) {
      var amount = (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
      return '\u00a3' + amount;
    }

    function initGallery(root) {
      var gallery = root.querySelector('[data-gallery]');
      if (!gallery) return;
      var thumbs = gallery.querySelectorAll('[data-thumb-index]');
      var slides = gallery.querySelectorAll('[data-slide-index]');
      var progress = gallery.querySelector('[data-progress]');
      var prev = gallery.querySelector('[data-prev]');
      var next = gallery.querySelector('[data-next]');
      var idx = 0;
      var total = slides.length;

      function show(i) {
        if (total === 0) return;
        idx = ((i % total) + total) % total;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
        if (progress) progress.style.width = ((idx + 1) / total * 100) + '%';
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.dataset.thumbIndex, 10)); });
      });
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });

      /* Switch gallery slide when the shared variant selector emits new:media-selected. */
      root.addEventListener('new:media-selected', function (e) {
        var mediaId = e.detail && e.detail.mediaId;
        if (!mediaId) return;
        var matchThumb = root.querySelector('[data-thumb-index][data-media-id="' + mediaId + '"]');
        if (matchThumb) show(parseInt(matchThumb.dataset.thumbIndex, 10));
      });

        // Swipe / drag the main image to change slides (mobile touch + desktop mouse drag)
        var stage = gallery.querySelector('[data-stage]');
        if (stage && total > 1) {
          var swX = 0, swY = 0, swActive = false, swDone = false, SW_THRESH = 40;
          function swStart(x, y) { swX = x; swY = y; swActive = true; swDone = false; }
          function swMove(x, y) {
            if (!swActive || swDone) return;
            var dx = x - swX, dy = y - swY;
            if (Math.abs(dx) > SW_THRESH && Math.abs(dx) > Math.abs(dy)) {
              swDone = true; swActive = false;
              show(idx + (dx < 0 ? 1 : -1));
            }
          }
          function swEnd() { swActive = false; }
          stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; swStart(t.clientX, t.clientY); }, { passive: true });
          stage.addEventListener('touchmove', function (e) { var t = e.touches[0]; swMove(t.clientX, t.clientY); }, { passive: true });
          stage.addEventListener('touchend', swEnd, { passive: true });
          stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; swStart(e.clientX, e.clientY); });
          stage.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') return; swMove(e.clientX, e.clientY); });
          window.addEventListener('pointerup', swEnd);
          stage.querySelectorAll('img').forEach(function (im) { im.addEventListener('dragstart', function (e) { e.preventDefault(); }); });
          stage.style.touchAction = 'pan-y';
        }
    }

    function initModeToggle(root) {
      var info = root.querySelector('.new-pm-pdp-info');
      if (!info) return;
      var chips = info.querySelector('[data-mode-chips]');
      var bundle = info.querySelector('[data-bundle]');
      var subPanel = info.querySelector('[data-subscribe]');
      var packPanel = info.querySelector('[data-pack-panel]');
      var sellingPlanInput = info.querySelector('[data-selling-plan-input]');
      var idInput = info.querySelector('[data-variant-id-input]');
      var qtyInput = info.querySelector('[data-quantity-input]');
      var atc = info.querySelector('[data-atc]');
      var compareDisplay = info.querySelector('[data-compare-display]');
      var klarnaAmount = info.querySelector('[data-klarna-amount]');

      var firstPriceEl = info.querySelector('[data-price-display]');
      var defaultVariantId = idInput ? idInput.dataset.defaultVariantId : '';
      var defaultPrice = firstPriceEl ? parseInt(firstPriceEl.dataset.defaultPrice || '0', 10) : 0;
      var defaultCompare = parseInt(info.dataset.defaultCompare || '0', 10);
      var bundleDefaultId = info.dataset.bundleDefaultVariantId || '';
      var bundleDefaultPrice = parseInt(info.dataset.bundleDefaultPrice || '0', 10);
      var bundleDefaultCompare = parseInt(info.dataset.bundleDefaultCompare || '0', 10);
      var bundleDefaultAvail = info.dataset.bundleDefaultAvailable === '1';
      var subVariantId = subPanel ? subPanel.dataset.subVariantId : '';
      var subWas = subPanel ? parseInt(subPanel.dataset.subWas || '0', 10) : 0;
      var subSelect = subPanel ? subPanel.querySelector('[data-selling-plan-select]') : null;
      var subDefaultPlanId = subPanel ? subPanel.dataset.defaultPlanId : '';
      var klarnaN = parseInt(root.dataset.klarnaInstallments || '3', 10);
      if (!klarnaN || klarnaN < 1) klarnaN = 3;

      // Tracks the last variant id/price chosen in Single Lash mode so we can
      // restore them correctly when returning from Subscribe or Bundle tabs.
      var lastSingleVariantId = defaultVariantId;
      var lastSinglePrice = defaultPrice;
      var lastSingleCompare = defaultCompare;
      var lastSingleQty = 1;
      var lashPicker = info.querySelector('[data-lash-picker]');

      function updateAtcLabel(price, available) {
        if (!atc) return;
        while (atc.firstChild) atc.removeChild(atc.firstChild);
        atc.disabled = !available;
        if (!available) {
          atc.appendChild(document.createTextNode('Sold out'));
          return;
        }
        atc.appendChild(document.createTextNode('Add to cart | '));
        var priceSpan = document.createElement('span');
        priceSpan.setAttribute('data-atc-price', '');
        priceSpan.textContent = formatMoney(price);
        atc.appendChild(priceSpan);
      }

      function updateHeaderPrice(price) {
        if (!info) return;
        info.querySelectorAll('[data-price-display]').forEach(function (el) {
          if (atc && atc.contains(el)) return;
          el.textContent = formatMoney(price);
        });
      }

      function setMode(newMode) {
        if (!chips) return;
        chips.querySelectorAll('[data-mode]').forEach(function (c) {
          var on = c.dataset.mode === newMode;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        if (packPanel) {
          if (newMode === 'single') packPanel.removeAttribute('hidden');
          else packPanel.setAttribute('hidden', '');
        }

        if (newMode === 'single') {
          if (lashPicker) lashPicker.removeAttribute('hidden');
          // Restore the last lash variant the shopper had selected
          if (idInput) idInput.value = lastSingleVariantId;
          if (qtyInput) qtyInput.value = lastSingleQty;
          if (subPanel) subPanel.setAttribute('hidden', '');
          if (sellingPlanInput) sellingPlanInput.value = '';
          if (bundle) bundle.setAttribute('hidden', '');
          updateAtcLabel(lastSinglePrice, true);
          updateHeaderPrice(lastSinglePrice);
          if (compareDisplay) {
            if (lastSingleCompare > lastSinglePrice) {
              compareDisplay.textContent = formatMoney(lastSingleCompare);
              compareDisplay.removeAttribute('hidden');
            } else {
              compareDisplay.setAttribute('hidden', '');
            }
          }
          if (klarnaAmount) klarnaAmount.textContent = formatMoney(Math.round(lastSinglePrice / klarnaN));

        } else if (newMode === 'subscribe') {
          if (lashPicker) lashPicker.setAttribute('hidden', '');
          // Subscribe adds the dedicated subscription product variant + selling plan
          var planId = (subSelect && subSelect.value) || subDefaultPlanId || '';
          var planPrice = subWas;
          if (subSelect && subSelect.options.length) {
            var opt = subSelect.options[subSelect.selectedIndex];
            if (opt && opt.getAttribute('data-plan-price')) planPrice = parseInt(opt.getAttribute('data-plan-price'), 10);
          } else if (subPanel && subPanel.dataset.subPrice) {
            planPrice = parseInt(subPanel.dataset.subPrice, 10);
          }
          if (idInput) idInput.value = subVariantId;
          if (qtyInput) qtyInput.value = 1;
          if (sellingPlanInput) sellingPlanInput.value = planId;
          if (bundle) bundle.setAttribute('hidden', '');
          if (subPanel) subPanel.removeAttribute('hidden');
          updateAtcLabel(planPrice, true);
          updateHeaderPrice(planPrice);
          if (compareDisplay) {
            if (subWas > planPrice) {
              compareDisplay.textContent = formatMoney(subWas);
              compareDisplay.removeAttribute('hidden');
            } else {
              compareDisplay.setAttribute('hidden', '');
            }
          }
          if (klarnaAmount) klarnaAmount.textContent = formatMoney(Math.round(planPrice / klarnaN));

        } else if (newMode === 'bundle') {
          if (lashPicker) lashPicker.setAttribute('hidden', '');
          if (idInput) idInput.value = bundleDefaultId;
          if (qtyInput) qtyInput.value = 1;
          if (subPanel) subPanel.setAttribute('hidden', '');
          if (sellingPlanInput) sellingPlanInput.value = '';
          if (bundle) bundle.removeAttribute('hidden');
          updateAtcLabel(bundleDefaultPrice, bundleDefaultAvail);
          updateHeaderPrice(bundleDefaultPrice);
          if (compareDisplay) {
            if (bundleDefaultCompare > bundleDefaultPrice) {
              compareDisplay.textContent = formatMoney(bundleDefaultCompare);
              compareDisplay.removeAttribute('hidden');
            } else {
              compareDisplay.setAttribute('hidden', '');
            }
          }
          if (klarnaAmount) klarnaAmount.textContent = formatMoney(Math.round(bundleDefaultPrice / klarnaN));
        }
      }

      if (chips) {
        chips.addEventListener('click', function (e) {
          var chip = e.target.closest('[data-mode]');
          if (chip) setMode(chip.dataset.mode);
        });
      }

      if (subSelect) {
        subSelect.addEventListener('change', function () {
          var active = chips && chips.querySelector('.is-active[data-mode="subscribe"]');
          if (active) setMode('subscribe');
        });
      }

      // Image-led selector: update price/ATC/compare when a lash variant is selected in Single mode
      root.addEventListener('new:variant-selected', function (e) {
        var v = e.detail && e.detail.variant;
        if (!v) return;
        // Only apply when in single mode
        var activeChip = chips && chips.querySelector('.is-active[data-mode]');
        if (activeChip && activeChip.dataset.mode !== 'single') return;
        var price = v.price;
        var compare = v.compare_at_price || 0;
        var available = v.available;
        if (idInput) idInput.value = String(v.id);
        lastSingleVariantId = String(v.id);
        lastSinglePrice = price;
        lastSingleCompare = compare;
        lastSingleQty = 1;
        updateAtcLabel(price, available);
        updateHeaderPrice(price);
        if (compareDisplay) {
          if (compare > price) {
            compareDisplay.textContent = formatMoney(compare);
            compareDisplay.removeAttribute('hidden');
          } else {
            compareDisplay.setAttribute('hidden', '');
          }
        }
        if (klarnaAmount) klarnaAmount.textContent = formatMoney(Math.round(price / klarnaN));
        // Update URL so Klarna OSM and back-button restore the correct variant
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (ignored) {}
      });

      // Option (variant) radio buttons — only update state when in single mode
      var optInputs = info.querySelectorAll('[data-option-input]');
      optInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          info.querySelectorAll('.new-pm-pdp-pack__card').forEach(function (l) { l.classList.remove('is-selected'); });
          var selectedCard = input.closest('.new-pm-pdp-pack__card');
          if (selectedCard) selectedCard.classList.add('is-selected');
          var price = parseInt(input.dataset.price || '0', 10);
          var compare = parseInt(input.dataset.compare || '0', 10);
          var qty = parseInt(input.dataset.packQty || '1', 10);
          // Always track the last single-mode selection
          if (input.dataset.variantId) lastSingleVariantId = input.dataset.variantId;
          lastSinglePrice = price;
          lastSingleCompare = compare;
          lastSingleQty = qty;
          // Only update the form + UI if currently in single mode
          var activeChip = chips && chips.querySelector('.is-active[data-mode]');
          if (activeChip && activeChip.dataset.mode !== 'single') return;
          if (idInput && input.dataset.variantId) idInput.value = input.dataset.variantId;
          if (qtyInput) qtyInput.value = qty;
          updateAtcLabel(price, true);
          updateHeaderPrice(price);
          if (compareDisplay) {
            if (compare > price) {
              compareDisplay.textContent = formatMoney(compare);
              compareDisplay.removeAttribute('hidden');
            } else {
              compareDisplay.setAttribute('hidden', '');
            }
          }
          if (klarnaAmount) klarnaAmount.textContent = formatMoney(Math.round(price / klarnaN));
        });
      });
    } // ← closes initModeToggle

    function boot() {
      document.querySelectorAll('.new-pm-pdp').forEach(function (root) {
        initGallery(root);
        initModeToggle(root);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();
  
/* ── Klarna OSM price sync loader ─────────────────────────────────────────
   Loads the shared NEW-klarna-sync.js (keeps Klarna instalment messaging in
   step with pack/bundle pickers — FCA accuracy). URL derived from this
   script's own src so it works on any CDN asset version. Idempotent. */
(function () {
  if (window.__nkKlarnaSyncV3 || document.querySelector('script[src*="NEW-klarna-sync"]')) return;
  var self = document.querySelector('script[src*="NEW-pre-mapped-pdp"]');
  if (!self || !self.src) return;
  var s = document.createElement('script');
  s.src = self.src.replace(/NEW-pre-mapped-pdp\.js[^"']*$/, 'NEW-klarna-sync.js');
  document.head.appendChild(s);
})();
